import { render, staticRenderFns } from "./_by-fornecedor.table.vue?vue&type=template&id=de6e95ac&scoped=true"
import script from "./_by-fornecedor.table.vue?vue&type=script&lang=js"
export * from "./_by-fornecedor.table.vue?vue&type=script&lang=js"
import style0 from "./_by-fornecedor.table.vue?vue&type=style&index=0&id=de6e95ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de6e95ac",
  null
  
)

export default component.exports